module.exports = __webpack_public_path__ + "static/dashbot_logo_w-7d561814b06bd310d92a1c87cc6d96a2.png";